import styled from "styled-components";

export const Wrapper = styled.div`
  .k16872421728962 {
    height: 100%;
    display: flex;
    padding: 110px 110px 110px 14px;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    background-color: rgba(255, 255, 255, 1);
  }

  .k16872423031813 {
    height: 70vh;
    display: flex;
    border-radius: 10px;
    flex-direction: row;
    background-color: rgba(244, 246, 248, 1);
  }

  .k168724855532724 {
    display: flex;
    padding: 8px;
    flex-direction: column;
  }

  .k168724857795225 {
    gap: 10px;
    display: flex;
    padding: 10px 10px 10px 0px;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }

  .k168724875378227 {
    width: 22px;
    height: 22px;
  }

  .k168724858459326 {
    color: rgba(40, 40, 40, 1);
    font-size: 16px;
  }

  .k16872526335851::-webkit-scrollbar-thumb {
    border-radius: 67px;
    background-color: rgba(203, 203, 203, 1);
  }

  .k16872526335851::-webkit-scrollbar-track {
  }

  .k16872526335851::-webkit-scrollbar {
    width: 5px;
  }

  .k16872526335851 {
    gap: 0px;
    flex: 1;
    width: 250px;
    cursor: pointer;
    display: flex;
    overflow: auto;
    border-radius: 10px;
    flex-direction: column;
    background-color: rgba(255, 255, 255, 1);
  }

  .k168724967226837 {
    gap: 10px;
    height: 70px;
    display: flex;
    padding: 0px 4px 0px 4px;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }

  .k168724967226837:hover, .k168724967226837.active {
    background-color: rgba(246, 246, 246, 1) !important;
  }
  .k168724967226837_ {
    background-color: rgba(246, 246, 246, 1) !important;
  }

  .k168724967226837:hover {
    background-color: rgba(235, 248, 242, 1) !important;
  }
  .k168724967226837_ {
    background-color: rgba(235, 248, 242, 1) !important;
  }

  .k168724943906431 {
    width: 40px;
    height: 40px;
    border-radius: 77px;
  }

  .k168724976549239 {
    display: flex;
    flex-direction: column;
  }

  .k168724971355738 {
    gap: 18px;
    display: flex;
    padding: 0px 5px 0px 0px;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }

  .k168724950079733 {
    font-size: 14px;
  }

  .k168724956248735 {
    color: rgba(120, 120, 120, 1);
    font-size: 12px;
  }

  .k168724977207640 {
    color: rgba(162, 162, 162, 1);
    font-size: 14px;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .k168724926627229 {
  }

  .k16872504636680 {
    flex: 1;
    display: flex;
    padding: 20px 20px 10px 10px;
    flex-direction: column;
  }

  .k16872509171916 {
  }

  .k16872505232561 {
    height: 36px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
  }

  .k16872505535012 {
  }

  .k16872505681403 {
    font-size: 20px;
  }

  .k16872507361824 {
    width: 100%;
    height: 1px;
    background-color: rgba(212, 212, 212, 1);
  }

  .k16872509276757::-webkit-scrollbar-thumb {
    border-radius: 67px;
    background-color: rgba(203, 203, 203, 1);
  }

  .k16872509276757::-webkit-scrollbar-track {
  }

  .k16872509276757::-webkit-scrollbar {
    width: 5px;
  }

  .k16872509276757 {
    height: 100%;
    margin: 0px 0px 5px 0px;
    display: flex;
    overflow: auto;
    flex-direction: column;
  }

  .k168725188100454 {
    padding: 0px 5px 0px 0px;
    display: flex;
    flex-direction: column-reverse;
  }

  .k16872509602488 {
    gap: 12px;
    width: 100%;
    margin: 20px 0px 0px 0px;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: end;
  }

  .k16872509602489 {
    gap: 8px;
    /* width: 100%; */
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    justify-content: flex-start;
  }

  .k168725111718116 {
    gap: 18px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;
  }

  .k168725214918166 {
    color: rgba(120, 120, 120, 1);
    font-size: 14px;
  }

  .k168725112465417 {
    color: rgba(120, 120, 120, 1);
    font-size: 14px;
  }

  .k168725096024810 {
    display: flex;
    padding: 14px 20px 14px 20px;
    /* max-width: 45%; */
    min-width: 150px;
    border-radius: 10px 0px 10px 10px;
    flex-direction: row;
    background-color: rgba(187, 213, 246, 1);
  }

  .k168725096024811 {
    color: rgba(0, 0, 0, 1);
    font-size: 14px;
    text-align: justify;
    line-height: 1.5;
  }

  .k168725096024814 {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 141px;
    background-size: cover;
    background-image: url("https://uniweb.superniu.cn/uploads/images/2023-03-16/14498e025880ce901defa40e1ea62ab0.jpeg");
    background-repeat: no-repeat;
    background-position: center;
  }

  .k168725122257418 {
    gap: 12px;
    width: 100%;
    margin: 20px 0px 0px 0px;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: flex-start;
  }

  .k168725122257424 {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 141px;
    background-size: cover;
    background-image: url("https://media.quhua.fun/uploads/811510847/CrMAOZqA5uLunMzunq65/6fdb9b0a0c5a96226eb8e833f.png");
    background-repeat: no-repeat;
    background-position: center;
  }

  .k168725122257419 {
    gap: 8px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .k168725122257420 {
    gap: 20px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }

  .k168725122257421 {
    color: rgba(16, 118, 251, 1);
    font-size: 14px;
  }

  .k168725225222667 {
    color: rgba(120, 120, 120, 1);
    font-size: 14px;
  }

  .k168725122257422 {
    display: flex;
    padding: 14px 20px 14px 20px;
    max-width: 45%;
    min-width: 50px;
    border-radius: 0px 10px 10px 10px;
    flex-direction: row;
    background-color: rgba(255, 255, 255, 1);
  }

  .k168725122257423 {
    color: rgba(0, 0, 0, 1);
    font-size: 14px;
    text-align: justify;
    line-height: 1.5;
  }

  .k168725252312968 {
    gap: 12px;
    width: 100%;
    margin: 20px 0px 0px 0px;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: flex-start;
  }

  .k168725252312969 {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 141px;
    background-size: cover;
    background-image: url("https://media.quhua.fun/uploads/811510847/CrMAOZqA5uLunMzunq65/6fdb9b0a0c5a96226eb8e833f.png");
    background-repeat: no-repeat;
    background-position: center;
  }

  .k168725252312970 {
    gap: 8px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .k168725252312971 {
    gap: 20px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }

  .k168725252312972 {
    color: rgba(16, 118, 251, 1);
    font-size: 14px;
  }

  .k168725252312973 {
    color: rgba(120, 120, 120, 1);
    font-size: 14px;
  }

  .k168725252312974 {
    display: flex;
    padding: 14px 20px 14px 20px;
    max-width: 45%;
    min-width: 50px;
    border-radius: 0px 10px 10px 10px;
    flex-direction: row;
    background-color: rgba(255, 255, 255, 1);
  }

  .k168725252312975 {
    color: rgba(0, 0, 0, 1);
    font-size: 14px;
    text-align: justify;
    line-height: 1.5;
  }

  .k168725252335176 {
    gap: 12px;
    width: 100%;
    margin: 20px 0px 0px 0px;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: flex-start;
  }

  .k168725252335177 {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 141px;
    background-size: cover;
    background-image: url("https://media.quhua.fun/uploads/811510847/CrMAOZqA5uLunMzunq65/6fdb9b0a0c5a96226eb8e833f.png");
    background-repeat: no-repeat;
    background-position: center;
  }

  .k168725252335178 {
    gap: 8px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .k168725252335179 {
    gap: 20px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }

  .k168725252335180 {
    color: rgba(16, 118, 251, 1);
    font-size: 14px;
  }

  .k168725252335181 {
    color: rgba(120, 120, 120, 1);
    font-size: 14px;
  }

  .k168725252335182 {
    display: flex;
    padding: 14px 20px 14px 20px;
    max-width: 45%;
    min-width: 50px;
    border-radius: 0px 10px 10px 10px;
    flex-direction: row;
    background-color: rgba(255, 255, 255, 1);
  }

  .k168725252335183 {
    color: rgba(0, 0, 0, 1);
    font-size: 14px;
    text-align: justify;
    line-height: 1.5;
  }

  .k168725252412884 {
    gap: 12px;
    width: 100%;
    margin: 20px 0px 0px 0px;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: flex-start;
  }

  .k168725252412885 {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 141px;
    background-size: cover;
    background-image: url("https://media.quhua.fun/uploads/811510847/CrMAOZqA5uLunMzunq65/6fdb9b0a0c5a96226eb8e833f.png");
    background-repeat: no-repeat;
    background-position: center;
  }

  .k168725252412886 {
    gap: 8px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .k168725252412887 {
    gap: 20px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }

  .k168725252412888 {
    color: rgba(16, 118, 251, 1);
    font-size: 16px;
  }

  .k168725252412889 {
    color: rgba(120, 120, 120, 1);
    font-size: 16px;
  }

  .k168725252412890 {
    display: flex;
    padding: 14px 20px 14px 20px;
    max-width: 45%;
    min-width: 50px;
    border-radius: 0px 10px 10px 10px;
    flex-direction: row;
    background-color: rgba(255, 255, 255, 1);
  }

  .k168725252412891 {
    color: rgba(0, 0, 0, 1);
    font-size: 14px;
    text-align: justify;
    line-height: 1.5;
  }

  .k168725153346626 {
    gap: 6px;
    height: 270px;
    display: flex;
    padding: 10px;
    border-radius: 10px;
    flex-direction: column;
    background-color: rgba(255, 255, 255, 1);
  }

  .k168725160955827 {
    gap: 13px;
    display: flex;
    padding: 0px 0px 0px 12px;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }

  .k168725171569928 {
    width: 24px;
    cursor: pointer;
    height: 24px;
  }

  .k168725173443329 {
    width: 24px;
    cursor: pointer;
    height: 24px;
  }

  .k168725190866955 {
    flex: 1;
  }

  .k168725192714256 {
    color: rgba(0, 0, 0, 1);
    width: 100%;
    height: 100%;
    padding: 10px;
    font-size: 14px;
  }

  .k168725202767064 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;
  }

  .k168725207355865 {
    width: 70px;
    height: 28px;
    display: flex;
    font-size: 14px;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    background-color: rgba(16, 118, 251, 1);
    border-radius: 6px;
    color: #fff;
  }
`;
